import Joi from "joi";
import FormValidationResult from "../../../../../../common/utils/validation/types/form-validation-result";
import userFormValidationService from "../../../../../../shared/user/user.validation.service";
import formValidationService from "../../../../../../common/utils/validation/form-validation.service";

const validateDispatch = (dispatchUuid: string): FormValidationResult => {
  const validationSchema = Joi.string().min(1).required();

  return formValidationService.validate(dispatchUuid, validationSchema);
};

const dispatcherAddByCargoFormValidationService = {
  validateDispatch,
  validateUsername: userFormValidationService.validateUsername,
  validatePassword: userFormValidationService.validatePassword,
  validatePasswordRepeat: userFormValidationService.validatePasswordRepeat,
  validateFirstName: userFormValidationService.validateFirstName,
  validateLastName: userFormValidationService.validateLastName,
  validatePhoneNumber: userFormValidationService.validateMobile,
  validateAlternativePhoneNumber:
    userFormValidationService.validateAlternativeMobile,
  validateEmail: userFormValidationService.validateEmail,
};

export default dispatcherAddByCargoFormValidationService;
